import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 border-t border-background-700/50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer whitespace-nowrap">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-movie-2-line text-primary-500 text-2xl"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-50">
                  夜猫影院
                </span>
              </Link>
              <p className="text-foreground-500 text-sm leading-relaxed">
                熬夜追剧首选夜间影视平台，汇聚海量电视剧、电影，深夜看电影、通宵追剧一站搞定。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    首页推荐
                  </Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    动作片
                  </Link>
                </li>
                <li>
                  <Link to="/category/scifi" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    科幻片
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
                影视分类
              </h4>
              <div className="flex flex-wrap gap-2">
                {categories.filter(c => c.slug !== 'all').map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-3 py-1 rounded-full bg-background-700/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 text-xs transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2 text-sm text-foreground-500">
                <li className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <span>contact@yemaocinema.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-primary-500"></i>
                  </div>
                  <span>400-888-夜猫</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-map-pin-line text-primary-500"></i>
                  </div>
                  <span>北京市朝阳区夜猫大厦</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-10 pt-6 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-600 text-xs">
              &copy; {currentYear} 夜猫影院 版权所有 | 京ICP备XXXXXXXX号
            </p>
            <div className="flex items-center gap-4 text-foreground-600 text-xs">
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}